import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#DCB868",
      lowOpacity: "#FFE0642E",
      low: "rgba(238, 213, 112, 0.67)",
    },
    secondary: {
      main: "#000000",
      lowOpacity: "#191919",
      contrastText: "#FFFFFF",
    },
    success: {
      main: "#4FE176",
      dark: "#17AD29",
    },
    error: {
      main: "#DE353F",
    },
    warning: {
      main: "#638CA6",
    },
    info: {
      main: "#BAD9F7",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#D9D9D9",
      disabled: "#d9d9d9b5",
      lowOpacity: "#C4C4C4",
    },
    grey: {
      500: "#515151",
    },
    background: {
      default: "#0c0c0c",
      paper: "#212121",
      white: "#fff",
      gray: "#666666",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 400,
      md: 600,
      lg: 900,
      xlg: 1000,
      xl: 1200,
      xxl: 1500,
      exl: 2000,
      tv: 2500,
    },
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          fontSize: "12px",
          "@media (min-width:600px)": {
            fontSize: "14px",
          },
          "@media (min-width:1200px)": {
            fontSize: "16px",
          },
          "@media (min-width:1500px)": {
            fontSize: "18px",
          },
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: ({ theme }) => ({
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(2),

          [theme.breakpoints.up("sm")]: {
            paddingLeft: theme.spacing(6),
            paddingRight: theme.spacing(6),
          },
          [theme.breakpoints.up("xl")]: {
            paddingLeft: theme.spacing(8),
            paddingRight: theme.spacing(8),
          },
        }),
      },
    },
  },
});

export default theme;
